module.exports = __webpack_public_path__ + "static/media/loading.7496ca4d.svg";